import { Navigate, Outlet, useLocation, useParams } from 'react-router'
import { defaultLocale, isLocale } from '@/lib/locales'
import { useAuthStore } from '@/stores/useAuthStore'
import { tokenNeedsVerification } from '@/lib/verificationConnexion'

export function AuthGuard() {
  const { locale } = useParams<{ locale: string }>()
  const location = useLocation()
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated())
  const needsCode = useAuthStore((s) => tokenNeedsVerification(s.accessToken))
  const lng = isLocale(locale) ? locale : defaultLocale

  if (!isAuthenticated) {
    const next = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/${lng}/login?next=${next}`} replace />
  }

  // Risky sign-in not yet confirmed: the server refuses everything else.
  if (needsCode) {
    const next = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/${lng}/verification?next=${next}`} replace />
  }

  return <Outlet />
}
